const map = {
	"./BTL/activaciones_icon.png": 2916,
	"./BTL/endomarketing_icon.png": 9465,
	"./BTL/eventos_icon.png": 9182,
	"./BTL_icon.png": 8792,
	"./Branding/concepto_icon.png": 8943,
	"./Branding/identidad_icon.png": 8626,
	"./Branding/manejo_icon.png": 3390,
	"./Branding/naming_icon.png": 102,
	"./Branding_icon.png": 1323,
	"./Marketing/admin_icon.png": 9346,
	"./Marketing/design_icon.png": 4707,
	"./Marketing/pauta_icon.png": 3292,
	"./Marketing_icon.png": 1578,
	"./Produccion/cabecera_icon.png": 8519,
	"./Produccion/gondola_icon.png": 2837,
	"./Produccion/letrero_icon.png": 6728,
	"./Produccion/stand_icon.png": 6519,
	"./Produccion_icon.png": 8972,
	"./Trade/auditoriaA_icon.png": 7204,
	"./Trade/auditoria_icon.png": 2083,
	"./Trade/estrategia_icon.png": 9114,
	"./Trade/estrategias_icon.png": 1361,
	"./Trade/merchandising_icon.png": 8535,
	"./Trade/old_personal_icon.png": 6961,
	"./Trade/old_promocion_icon.png": 1963,
	"./Trade/personal_icon.png": 6367,
	"./Trade/promocion_icon.png": 7709,
	"./Trade_icon.png": 7956,
	"./goBack_icon.png": 4545
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3595;